import AppLibrary from '../app-library';
import PreOrder from '../pre-order';

export default class ProductPrice {
  /**
   * @type {HTMLElement}
   */
  #priceElement;

  /**
   * @type {boolean}
   */
  #wasChanged = false;

  /**
   * @type {AppConfig}
   */
  #config;

  /**
   * @type {PreOrder}
   */
  #preOrder;

  /**
   * @type {{}}
   */
  #global;

  /**
   * @type {{}}
   */
  #variant;

  /**
   * @type {{}}
   */
  #settings;

  /**
   * @type {number}
   */
  #lastErrorTimsMs = 0;

  /**
   * @param {HTMLElement} priceElement
   * @param {AppConfig} config
   * @param {PreOrder} preOrder
   */
  constructor (priceElement, config, preOrder) {
    this.#priceElement = priceElement;
    this.#config = config;
    this.#preOrder = preOrder;

    this.#global = window.Spurit.global;
    let moneyFormat = this.#global.prices.money.getFormatDefault() || this.#global.snippet.moneyFormat;
    this.#global.prices.money.setFormatDefault(moneyFormat + ' ');
  }

  /**
   *
   */
  checkAndDisplay () {
    if (this.#lastErrorTimsMs && (new Date()).getTime() - this.#lastErrorTimsMs < 5000) {
      return;
    }
    if (!this.#priceElement || !this.#priceElement.parentNode) {
      return;
    }
    this.#global.atc.lineItemByTargetElement(this.#priceElement, lineItem => {
      if (this.#variant === null && !lineItem) {
        return;
      }

      if (!lineItem) {
        AppLibrary.consoleLog(
          {error: 'Can\'t find line-item for given price-element', element: this.#priceElement},
          'warn'
        );
        this.#lastErrorTimsMs = (new Date()).getTime();
        this.#variant = null;
        return;
      }

      this.#variant = this.#config.snippet().getVariantDetails(lineItem.id);
      if (!this.#variant) {
        AppLibrary.consoleLog(`Can't find variant details by ID ${lineItem.id}`, 'warn');
        this.#lastErrorTimsMs = (new Date()).getTime();
        return;
      }

      this.#settings = this.#config.getSettingsByVariantId(this.#variant.id);
      if (!this.#settings) {
        AppLibrary.consoleLog(`No pre-order settings for variant ${this.#variant.id}`);
        this.#lastErrorTimsMs = (new Date()).getTime();
        return;
      }
      if (!this.#settings.discount.value) {
        return;
      }

      let status = this.#preOrder.preorderStatusForVariant(this.#variant, this.#settings);
      if (status === PreOrder.PREORDER_STATUS_ENABLED) {
        this.#displayDiscount();
      } else {
        this.#clearDiscount();
      }
    });
  }

  /**
   *
   */
  #displayDiscount () {
    let price = this.#variant.price / 100;
    let discountedPrice = this.#getDiscountedPrice(this.#variant, this.#settings.discount);

    if (this.#variant.compare_at_price) {
      this.#global.prices.displayNewPrice(this.#priceElement, discountedPrice, discountedPrice);
    } else {
      this.#global.prices.displayNewPrice(this.#priceElement, discountedPrice, price);
    }
    this.#wasChanged = true;
  }

  /**
   *
   */
  #clearDiscount () {
    if (!this.#wasChanged) {
      return;
    }
    let price = this.#variant.price / 100;
    this.#global.prices.displayNewPrice(this.#priceElement, price, price);
    this.#wasChanged = false;
  }

  /**
   * @param {{price: number}} variant
   * @param {{value: number, type: string}} discount
   * @return {number}
   */
  #getDiscountedPrice (variant, discount) {
    return this.#global.cartPool.calculateDiscount(
      variant.price / 100,
      [discount]
    );
  }
}